import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M25 15c0 5.5228-4.4772 10-10 10m10-10c0-5.5229-4.4772-10-10-10m10 10H5m10 10C9.4771 25 5 20.5228 5 15m10 10a15.301 15.301 0 0 0 4.0007-10A15.3008 15.3008 0 0 0 15 5m0 20a15.299 15.299 0 0 1-3.9993-10A15.2989 15.2989 0 0 1 15 5M5 15C5 9.4771 9.4771 5 15 5M7.5 25c0 1.3807-1.1193 2.5-2.5 2.5S2.5 26.3807 2.5 25s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Zm20 0c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5ZM7.5 5c0 1.3807-1.1193 2.5-2.5 2.5S2.5 6.3807 2.5 5 3.6193 2.5 5 2.5 7.5 3.6193 7.5 5Zm20 0c0 1.3807-1.1193 2.5-2.5 2.5S22.5 6.3807 22.5 5s1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }